// component
/* eslint-disable */
import SvgColor from '../../../components/svg-color';
import pls from '../../../assets/PLS.png';
import Iconify from '../../../components/iconify';
// import { ROLES } from '../../../constant/constant';
import { ROLES } from 'src/utils/enums';

// ----------------------------------------------------------------------
const icon = (name) => (
  <img src={`/assets/icons/navbar/${name}.svg`} alt={name} style={{ width: '22px', height: '22px' }} />
);
const user = localStorage.getItem('technisches');
const userData = JSON.parse(user);
// console.log(userData?.user?.nav);

const navConfig = [
  {
    title: 'Process Bookings',
    path: '/processBookings',
    // icon: icon('ic_user'),
    icon: <Iconify icon={'mdi:hotel'} width={20} sx={{ cursor: 'pointer' }} />,
  },

  // {
  //   title: 'Database Explorer',
  //   path: '/database/explorer',
  //   icon: <Iconify icon={'mdi:database-search'} width={20} sx={{ cursor: 'pointer' }} />,
  // },

  {
    title: 'Users',
    path: '/users',
    // icon: icon('ic_user'),
    icon: <Iconify icon={'eva:people-fill'} width={20} sx={{ cursor: 'pointer' }} />,
  },
  {
    title: 'BnBs',
    path: '/bnb',
    // icon: icon('ic_user'),
    icon: <Iconify icon={'eva:home-outline'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'BnB List',
        path: '/bnb/bnbList',
        icon: <Iconify icon={'mdi:format-list-bulleted'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'BnB Configuration',
        path: '/bnb/bnbDetail',
        icon: <Iconify icon={'mdi:cog-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  {
    title: 'Door List',
    path: '/door',
    icon: <Iconify icon={'emojione-monotone:door'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Door List',
        path: '/door/doorList',
        icon: <Iconify icon={'mdi:view-list'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Default Setting',
        path: '/door/doorSetttings',
        icon: <Iconify icon={'mdi:application-cog'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },
  {
    title: 'Special Access',
    path: '/specialAccess',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'mdi:shield-key-outline'} width={20} sx={{ cursor: 'pointer' }} />,
  },

  {
    title: 'Travel Guide',
    path: '/travelGuide', // Parent path
    icon: <Iconify icon={'ic:sharp-travel-explore'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'City',
        path: '/travelGuide/city',
        icon: <Iconify icon={'mdi:city-variant-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Assign City',
        path: '/travelGuide/assignCity',
        icon: <Iconify icon={'mdi:map-marker-radius-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Category',
        path: '/travelGuide/category',
        icon: <Iconify icon={'mdi:shape-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Travel Guide Items',
        path: '/travelGuide/info',
        icon: <Iconify icon={'mdi:book-open-page-variant-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },
  {
    title: 'Refills',
    path: '/refill', // Parent path
    icon: <Iconify icon={'mdi:paper-towels-outline'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Refill Items',
        path: '/refill/refillItems',
        icon: <Iconify icon={'mdi:bottle-tonic-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Assign Refill',
        path: '/refill/assignRefill',
        icon: <Iconify icon={'mdi:clipboard-list-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Refill Requests',
        path: '/refill/refillRequest',
        icon: <Iconify icon={'mdi:cart-arrow-down'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },
  {
    title: 'Extra Cleanings',
    path: '/cleaning', // Parent path
    icon: <Iconify icon={'guidance:cleaning-room'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Cleaning Items',
        path: '/cleaning/cleaningItems',
        icon: <Iconify icon={'hugeicons:towels'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Assign Cleaning',
        path: '/cleaning/assignCleaning',
        icon: <Iconify icon={'mdi:clipboard-list-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Cleaning Requests',
        path: '/cleaning/cleaningRequest',
        icon: <Iconify icon={'heroicons-outline:clipboard-document-check'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Settings',
        path: '/cleaning/extraCleaningSettings',
        icon: <Iconify icon={'heroicons-outline:cog'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  {
    title: 'Cleaners',
    path: '/cleaners', // Parent path
    icon: <Iconify icon={'healthicons:domestic-worker-alt'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Cleaner List',
        path: '/cleaners/cleaner',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'material-symbols:cleaning-services-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Overview',
        path: '/cleaners/overview',
        icon: <Iconify icon={'mdi:map-marker-radius-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Special Cleaner',
        path: '/cleaners/specialCleaner',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'material-symbols:star-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Cleaning Report',
        path: '/cleaners/cleaningReport',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'ant-design:file-done-outlined'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Averages',
        path: '/cleaners/averages',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'material-symbols:analytics-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Cleaning Cost',
        path: '/cleaners/cleaningCost',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'heroicons-outline:currency-dollar'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Monthly Statement',
        path: '/cleaners/statement',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'heroicons-outline:clipboard-document-list'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Cleaner Settings',
        path: '/cleaners/cleanerSettings',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'heroicons-outline:cog'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  // {
  //   title: 'Contracts',
  //   path: '/contractor', // Parent path
  //   icon: <Iconify icon={'clarity:contract-line'} width={20} sx={{ cursor: 'pointer' }} />,
  //   children: [
  //     {
  //       title: 'Links',
  //       path: '/contractor/contractorList',
  //       // icon: icon('ic_notification_package'),
  //       icon: <Iconify icon={'mdi:link-box-outline'} width={20} sx={{ cursor: 'pointer' }} />,
  //     },
  //     {
  //       title: 'Templates',
  //       path: '/contractor/contractTemplates',
  //       // icon: icon('ic_notification_package'),
  //       icon: (
  //         <Iconify
  //           icon={'streamline:industry-innovation-and-infrastructure-solid'}
  //           width={20}
  //           sx={{ cursor: 'pointer' }}
  //         />
  //       ),
  //     },
  //     {
  //       title: 'Signed',
  //       path: '/contractor/signed',
  //       // icon: icon('ic_notification_package'),
  //       icon: <Iconify icon={'fluent:signed-24-regular'} width={20} sx={{ cursor: 'pointer' }} />,
  //     },
  //     // {
  //     //   title: 'Settings',
  //     //   path: '/contractor/settings',
  //     //   // icon: icon('ic_notification_package'),
  //     //   icon: <Iconify icon={'mdi:cog-outline'} width={20} sx={{ cursor: 'pointer' }} />,
  //     // },
  //   ],
  // },

  {
    title: 'Luggage Storage',
    path: '/luggageStorage', // Parent path
    icon: <Iconify icon={'material-symbols:luggage'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Storage List',
        path: '/luggageStorage/luggage',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'heroicons-outline:folder'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Storage Doors',
        path: '/luggageStorage/luggageDoors',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'cbi:panel-door-open'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Activity Logs',
        path: '/luggageStorage/luggageLogs',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'fluent:shifts-activity-24-filled'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  {
    title: 'Parking',
    path: '/parking', // Parent path
    icon: <Iconify icon={'fluent-mdl2:parking-location-mirrored'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Parking Area',
        path: '/parking/parkingArea',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'tdesign:location-parking-place'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Garage',
        path: '/parking/garage',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'cbi:garage-alt-open'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Private Parking',
        path: '/parking/private_parking',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:garage-lock'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  {
    title: 'Trash',
    path: '/trash', // Parent path
    icon: <Iconify icon={'covid:transmission-virus-trash-bin'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Trash Map',
        path: '/trash/trashMap',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:map-marker-radius'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Trash Items',
        path: '/trash/trashItems',
        icon: <Iconify icon={'eva:trash-2-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Trash Days',
        path: '/trash/trashDays',
        icon: <Iconify icon={'lucide:calendar-days'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  {
    title: 'Maintenance',
    path: '/maintananceDetail',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'wpf:maintenance'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Maintenance Request',
        path: '/maintananceDetail/maintanance',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'heroicons-outline:clipboard-document-check'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Repair Man',
        path: '/maintananceDetail/repairman',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:account-wrench-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  {
    title: 'Shelly Integrations',
    path: '/shellyIntegrations',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'material-symbols:home-iot-device'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Devices List',
        path: '/shellyIntegrations/devices',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:devices'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Water heaters',
        path: '/',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:water-boiler'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Modem Reset',
        path: '/',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mingcute:router-modem-fill'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Notifications',
        path: '/',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:bell-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Settings',
        path: '/shellyIntegrations/shellySetting',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:cog-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },
  // {
  //   title: 'TT lock',
  //   path: '/shellyIntegrations',
  //   // icon: icon('ic_notification_package'),
  //   icon: <Iconify icon={'material-symbols:home-iot-device'} width={20} sx={{ cursor: 'pointer' }} />,
  //   children: [
  //     {
  //       title: 'Devices List',
  //       path: '/ttlock/devices',
  //       // icon: icon('ic_notification_package'),
  //       icon: <Iconify icon={'mdi:devices'} width={20} sx={{ cursor: 'pointer' }} />,
  //     },

  //     {
  //       title: 'Settings',
  //       path: '/ttlock/settings',
  //       // icon: icon('ic_notification_package'),
  //       icon: <Iconify icon={'mdi:cog-outline'} width={20} sx={{ cursor: 'pointer' }} />,
  //     },
  //   ],
  // },

  {
    title: 'Twilio Integrations',
    path: '/twilioIntegrations',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'gg:twilio'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'Phone Numbers',
        path: '/twilioIntegrations/phoneNumbers',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:phone-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Settings',
        path: '/twilioIntegrations/setting',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:cog-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  {
    title: 'FAQs',
    path: '/faqs',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'eva:question-mark-circle-outline'} width={20} sx={{ cursor: 'pointer' }} />,
  },

  {
    title: 'Chat',
    path: '/chat', // Parent path
    icon: <Iconify icon={'eva:message-circle-outline'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      // {
      //   title: 'Inbox',
      //   path: '/chat/chat',
      //   // icon: icon('ic_notification_package'),
      //   icon: <Iconify icon={'fluent:mail-inbox-arrow-down-20-filled'} width={20} sx={{ cursor: 'pointer' }} />,
      // },
      {
        title: 'Settings',
        path: '/chat/setting',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'eva:settings-outline'} width={20} sx={{ cursor: 'pointer' }} />,
      },
      {
        title: 'Preset Message',
        path: '/chat/presetMessage',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'eos-icons:stateful-set'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },

  {
    title: 'Taxi',
    path: '/texi',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'emojione-monotone:oncoming-taxi'} width={20} sx={{ cursor: 'pointer' }} />,
  },
  {
    title: 'Neighborhood',
    path: '/aroundUs',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'iconoir:neighbourhood'} width={20} sx={{ cursor: 'pointer' }} />,
  },
  {
    title: 'PMS',
    path: '/pms',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'carbon:api-1'} width={20} sx={{ cursor: 'pointer' }} />,
    children: [
      {
        title: 'KrossBooking',
        path: '/pms/krossBooking',
        // icon: icon('ic_notification_package'),
        icon: <Iconify icon={'mdi:sword-cross'} width={20} sx={{ cursor: 'pointer' }} />,
      },
    ],
  },
  // {
  //   title: 'Smart Things',
  //   path: '/smart-home',
  //   // icon: icon('ic_notification_package'),
  //   icon: <Iconify icon={'material-symbols:home-iot-device'} width={20} sx={{ cursor: 'pointer' }} />,
  //   children: [
  //     {
  //       title: 'Devices',
  //       path: '/smart-home/devices',
  //       // icon: icon('ic_notification_package'),
  //       icon: <Iconify icon={'mdi:devices'} width={20} sx={{ cursor: 'pointer' }} />,
  //     },
  //     {
  //       title: 'Settings',
  //       path: '/smart-home/settings',
  //       // icon: icon('ic_notification_package'),
  //       icon: <Iconify icon={'mdi:cog-outline'} width={20} sx={{ cursor: 'pointer' }} />,
  //     },
  //   ],
  // },
  // {
  //   title: 'Smart Home',
  //   path: '/smart-homes',
  //   // icon: icon('ic_notification_package'),
  //   icon: <Iconify icon={'mdi:home-automation'} width={20} sx={{ cursor: 'pointer' }} />,
  // },
  {
    title: 'WebApp Settings',
    path: '/webappSettings',
    // icon: icon('ic_notification_package'),
    icon: <Iconify icon={'carbon:application-web'} width={20} sx={{ cursor: 'pointer' }} />,
  },

  // {
  //   title: 'Log out',
  //   path: '/logout',
  //   // icon: icon('ic_notification_package'),
  //   icon: <Iconify icon={'eva:log-out-fill'} width={20} sx={{ cursor: 'pointer' }} />,
  // },
];

// eslint-disable-next-line
// let filteredNavConfig;
// if (userData?.user?.email === 'timelesspuglia@gmail.com') {
//   filteredNavConfig = navConfig;
// } else {
//   filteredNavConfig = navConfig.filter((navItem) => userData?.user?.nav?.includes(navItem.path));
// }
let filteredNavConfig;
if (
  userData?.user?.role?.name.trim() === ROLES.OWNER.trim() ||
  userData?.user?.role?.name.trim() === ROLES.ADMIN.trim()
) {
  // console.log('userData?.user?.role?.name', userData?.user?.role?.name, 'ROLES.OWNER', ROLES.OWNER);
  filteredNavConfig = navConfig;
} else {
  filteredNavConfig = navConfig.filter((navItem) => userData?.user?.nav?.includes(navItem.path));
}

export default filteredNavConfig;

// const navConfig = getNavConfig(userData?.user?.role?.name);

//  const getNavConfig = (role) => {
//   if (role === ROLES.ADMIN) {
//     return [
//       {
//         title: 'Dashboard',
//         path: '/app',
//         //  icon: icon('ic_analytics'),
//         icon: <Iconify icon={'eva:grid-fill'} width={20} sx={{ cursor: 'pointer' }} />,
//       },

//       {
//         title: 'Process Bookings',
//         path: '/processBookings',
//         // icon: icon('ic_user'),
//         icon: <Iconify icon={'eva:plus-square-fill'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Users',
//         path: '/users',
//         // icon: icon('ic_user'),
//         icon: <Iconify icon={'eva:people-fill'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'BnB List',
//         path: '/bnbList',
//         // icon: icon('ic_user'),
//         icon: <Iconify icon={'mdi-view-grid-plus'} width={20} sx={{ cursor: 'pointer' }} />,
//       },

//       {
//         title: 'Door List',
//         path: '/doorList',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'mdi-bullhorn'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Special Access',
//         path: '/specialAccess',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:link-2-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Travel Guide',
//         path: '/travelGuide', // Parent path
//         icon: <Iconify icon={'eva:globe-2-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         children: [
//           {
//             title: 'City',
//             path: '/travelGuide/city',
//             icon: <Iconify icon={'eva:shake-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Assign City',
//             path: '/travelGuide/assignCity',
//             icon: <Iconify icon={'eva:shake-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Category',
//             path: '/travelGuide/category',
//             icon: <Iconify icon={'eva:layers-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Travel Guide Items',
//             path: '/travelGuide/info',
//             icon: <Iconify icon={'eva:globe-2-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//         ],
//       },
//       {
//         title: 'Refill Detail',
//         path: '/refill', // Parent path
//         icon: <Iconify icon={'eva:shopping-bag-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         children: [
//           {
//             title: 'Refill Items',
//             path: '/Refill Detail/refillItems',
//             icon: <Iconify icon={'eva:shake-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Assign Refill',
//             path: '/Refill Detail/assignRefill',
//             icon: <Iconify icon={'eva:shake-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Refill Requests',
//             path: '/Refill Detail/refillRequest',
//             icon: <Iconify icon={'eva:layers-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },

//         ],
//       },
//       {
//         title: 'Extra Cleanings',
//         path: '/cleaning', // Parent path
//         icon: <Iconify icon={'eva:shopping-bag-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         children: [
//           {
//             title: 'Cleaning Items',
//             path: '/cleaning/cleaningItems',
//             icon: <Iconify icon={'eva:shake-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Assign Cleaning',
//             path: '/cleaning/assignCleaning',
//             icon: <Iconify icon={'eva:shake-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Cleaning Requests',
//             path: '/cleaning/cleaningRequest',
//             icon: <Iconify icon={'eva:layers-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },

//         ],
//       },

//       {
//         title: 'Cleaners',
//         path: '/cleaners', // Parent path
//         icon: <Iconify icon={'eva:shopping-bag-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         children: [
//           {
//             title: 'Cleaner List',
//             path: '/cleaners/cleaner',
//             // icon: icon('ic_notification_package'),
//             icon: <Iconify icon={'eva:clipboard-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Cleaning Report',
//             path: '/cleaners/cleaningReport',
//             // icon: icon('ic_notification_package'),
//             icon: <Iconify icon={'eva:clipboard-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//           },

//         ],
//       },

//       {
//         title: 'Luggage Storage',
//         path: '/luggageStorage', // Parent path
//         icon: <Iconify icon={'eva:shopping-bag-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         children: [

//       {
//         title: 'Storage List',
//         path: '/luggageStorage/luggage',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:briefcase-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Storage Doors',
//         path: '/luggageStorage/luggageDoors',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:briefcase-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Activity Logs',
//         path: '/luggageStorage/luggageLogs',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:briefcase-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },

//         ],
//       },

//       {
//         title: 'Parking',
//         path: '/parking', // Parent path
//         icon: <Iconify icon={'mdi:car-brake-parking'} width={20} sx={{ cursor: 'pointer' }} />,
//         children: [
//           {
//             title: 'Parking Area',
//             path: '/parking/parkingArea',
//             // icon: icon('ic_notification_package'),
//             icon: <Iconify icon={'mdi:car-brake-parking'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Garage',
//             path: '/parking/garage',
//             // icon: icon('ic_notification_package'),
//             icon: <Iconify icon={'mdi:garage-variant'} width={20} sx={{ cursor: 'pointer' }} />,
//           },
//           {
//             title: 'Private Parking',
//             path: '/parking/private_parking',
//             // icon: icon('ic_notification_package'),
//             icon: <Iconify icon={'mdi:car-brake-parking'} width={20} sx={{ cursor: 'pointer' }} />,
//           },

//         ],
//       },

//       {
//         title: 'FAQs',
//         path: '/faqs',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:question-mark-circle-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Chat',
//         path: '/chat',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:message-circle-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Maintanance',
//         path: '/maintanance',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:settings-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Taxi',
//         path: '/texi',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:car-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Around Us',
//         path: '/aroundUs',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:home-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Auth Token',
//         path: '/authToken',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:message-square-fill'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'WebApp Settings',
//         path: '/webappSettings',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:phone-call-fill'} width={20} sx={{ cursor: 'pointer' }} />,
//       },

//       {
//         title: 'Log out',
//         path: '/logout',
//         // icon: icon('ic_notification_package'),
//         icon: <Iconify icon={'eva:log-out-fill'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//     ];
//   }  if (role === ROLES.TRAVEL_GUIDER) {
//     return [
//       {
//         title: 'dashboard',
//         path: '/app',
//         //  icon: icon('ic_analytics'),
//         icon: <Iconify icon={'eva:grid-fill'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//     {
//       title: 'Travel Guide',
//       path: '/travelGuide', // Parent path
//       icon: <Iconify icon={'eva:globe-2-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       children: [
//         {
//           title: 'City',
//           path: '/travelGuide/city',
//           icon: <Iconify icon={'eva:shake-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         },
//         {
//           title: 'Assign City',
//           path: '/travelGuide/assignCity',
//           icon: <Iconify icon={'eva:shake-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         },
//         {
//           title: 'Category',
//           path: '/travelGuide/category',
//           icon: <Iconify icon={'eva:layers-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         },
//         {
//           title: 'Travel Guide Items',
//           path: '/travelGuide/info',
//           icon: <Iconify icon={'eva:globe-2-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//         },
//       ],
//     }]
//   }
//     return [
//       {
//         title: 'dashboard',
//         path: '/app',
//         //  icon: icon('ic_analytics'),
//         icon: <Iconify icon={'eva:grid-fill'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//       {
//         title: 'Maintanance',
//         path: '/maintanance',
//         icon: <Iconify icon={'eva:settings-outline'} width={20} sx={{ cursor: 'pointer' }} />,
//       },
//     ];

// };

//   const navConfig = getNavConfig(userData?.user?.role?.name);
